import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["unit", "button", "dose_invisible", "autocomplete"]

  initialize() {
    this.use_dose = false
  }

  switch() {
    this.use_dose = !this.use_dose
    this.unitTargets.forEach(element => {
      if (this.use_dose) {
        element.textContent = '袋'
      } else {
        element.textContent = 'g'
      }
    });
    this.buttonTargets.forEach(element => {
      if (this.use_dose) {
        element.classList.remove('bg-blue')
        element.classList.add('bg-green')
      } else {
        element.classList.remove('bg-green')
        element.classList.add('bg-blue')
      }
    });
    this.dose_invisibleTargets.forEach(element => {
      element.hidden = this.use_dose
    });
    this.autocompleteTargets.forEach(element => {
      if (this.use_dose) {
        element.setAttribute('data-behavior', 'autocomplete-dose')
      } else {
        element.setAttribute('data-behavior', 'autocomplete')
      }
    });

  }

}